import Card from '@/components/UI/Card';
import { formatEnumLabel, formatMetric } from './helpers';
import type { ObvAuditEventRow } from './types';

interface FocusedEventsCardProps {
    selectedEvents: ObvAuditEventRow[];
}

const FocusedEventsCard = ({ selectedEvents }: FocusedEventsCardProps) => (
    <Card responsivePadding bodyClassName="space-y-4" title="Focused Events">
        {selectedEvents.length === 0 ? (
            <div className="text-sm text-zinc-400">No OBV events occurred on the focused datetime.</div>
        ) : (
            <div className="space-y-3">
                {selectedEvents.map((eventRow) => (
                    <div
                        className="rounded-lg border border-zinc-800 bg-zinc-950/70 p-4 text-sm text-zinc-200"
                        key={`${eventRow.dateTime}:${eventRow.event.type}`}
                    >
                        <div className="flex items-center justify-between gap-3">
                            <div className="font-medium text-zinc-100">{formatEnumLabel(eventRow.event.type)}</div>
                            <div className="text-zinc-500">{eventRow.dateTime}</div>
                        </div>
                        <div className="mt-2 grid gap-2 md:grid-cols-2">
                            <div>Flow Balance 20: {formatMetric(eventRow.event.flowBalance20, 3)}</div>
                            <div>Signal Distance: {formatMetric(eventRow.event.signalDistance, 3)}</div>
                            <div>Local Percentile: {formatMetric(eventRow.event.localPercentile, 3)}</div>
                            <div>Divergence: {eventRow.event.divergenceType ? formatEnumLabel(eventRow.event.divergenceType) : 'n/a'}</div>
                        </div>
                    </div>
                ))}
            </div>
        )}
    </Card>
);

export default FocusedEventsCard;
